import apiFetch from '../apiFetch'

export default function (token, campaign) {
  return apiFetch({ endPoint: 'CampaignDetails/Create', method: 'POST', body: campaign, token: token })
}
